import React, { useEffect, useRef, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast } from "react-toastify";
import { useOutletContext } from "react-router";
import axios from "axios";
import { useSelector } from "react-redux";

import ImageUploadAdapterPlugin from "../../../../../utils/ImageUploadAdapter";

import { HelpContainer } from "../../../shopping/component/styled/defaultTheme";
import useUploadFiles from "../../../../../hooks/useUploadFiles";

const HelpForm = ({
  formData,
  setFormData,
  cancelEvent = null,
  openModal,
  closeModal,
  getInquiries,
  setActive,
}) => {
  const { cmpnyNo, theme } = useOutletContext();
  const { uploadEmbedded } = useUploadFiles();

  const user = useSelector((state) => state?.user?.data[0]);

  const ckeditorInstanceRef = useRef(null);

  const handleEditorChange = (_, editor) => {
    const newContent = editor.getData();
    setFormData((data) => ({ ...data, content: newContent }));
  };

  const changeInput = (e) => {
    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  // 문의 작성, 수정
  const submitInquiry = async () => {
    try {
      const content = await uploadEmbedded(formData.content);

      const url = `/erp/inquiry/${formData.id ? "update" : "create"}`;
      const body = {
        ...formData,
        content: content,
        mberNo: user.mberNo,
        cmpnyNo,
      };

      const res = await axios.post(url, body);

      if (res.status === 200) {
        toast.success(`문의가 ${formData.id ? "수정" : "작성"}되었습니다.`);
        getInquiries();
        closeModal();
        setActive(0);
      }
    } catch (error) {
      console.error(error);
      toast.error("문의 등록 중 오류가 발생했습니다.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.title || !formData.content) {
      toast.error("제목과 내용을 적어주세요.");
      return;
    }

    openModal({
      isOpen: true,
      type: "confirmation",
      title: `${formData?.id ? "문의 수정" : "문의 작성"}`,
      message: [`문의를 ${formData?.id ? "수정" : "작성"}하시겠습니까?`],
      handleConfirm: () => submitInquiry(),
      handleCancel: () => closeModal(),
    });
  };

  return (
    <HelpContainer className={`theme-${theme}`}>
      <div className="title">
        <span className="tit">문의제목</span>
        <div className="cont">
          <input
            type="text"
            placeholder="문의제목을 작성해주세요."
            onChange={changeInput}
            name="title"
            value={formData.title}
          />
        </div>
      </div>
      <div className="content">
        <span className="tit">문의내용</span>
        <div className="cont">
          <CKEditor
            editor={ClassicEditor}
            data={formData.content}
            onChange={handleEditorChange}
            config={{
              extraPlugins: [ImageUploadAdapterPlugin],
              toolbar: ["bold", "italic", "imageUpload"],
            }}
            ref={ckeditorInstanceRef}
          />
        </div>
      </div>
      <div className="buttons">
        <button onClick={handleSubmit}>확인</button>
        <button onClick={cancelEvent}>취소</button>
      </div>
    </HelpContainer>
  );
};

export default HelpForm;
